import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common';
import { Platform } from 'ionic-angular';

@Injectable()
export class AvatarProvider {

  constructor(public http: HttpClient,
    private commonService: CommonProvider,
    private plt: Platform) {}

  private _url: string = 'api/v1/avatar';

  avatarContent:string;

  get(id: string): Observable<Response<Avatar>> {
    return this.http.get<Response<Avatar>>(this.commonService.apiUrl + this._url + `/${id}`);
  }

}

export interface Avatar {
  avatar_content;
}


// WEBPACK FOOTER //
// ./src/providers/avatar/avatar.ts